import React, { Suspense, useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import HeaderShimmer from "./Header/Header.shimmer";
const Header = React.lazy(() => import("./Header/Header"));
const Footer = React.lazy(() => import("./Footer/footer"));
import classes from "./index.module.css";
import bookLogo from "../../assets/images/book.webp";
import { Link, useLocation } from "react-router-dom";
const FeedbackForm = React.lazy(() =>
  import("../../components/Feedback/FeedbackForm")
);
import { Offcanvas } from "bootstrap";
import { useMegaMenu } from "../../Pregrine/MegaMenu/useMegaMenu";
import { useCartTrigger } from "../../Pregrine/cartTrigger/useCartTrigger";
import { GET_ITEM_COUNT_QUERY } from "../../Pregrine/cartTrigger/cartTrigger.gql";
import EnquiryForm from "../../components/EnquiryForm/EnquiryForm";
import { useDispatch, useSelector } from "react-redux";
import { saveShowEnquireNow } from "../../features/HomePage/HomePageSlice";

const Layout = ({ children }) => {
  const { showEnquireNow } = useSelector((state) => state.homePageSlice);
  const [showFeedback, setShowFeedback] = useState(false);
  const [ShowEnquireFormNow, setShowEnquireFormNow] = useState(false);
  const isFormFocusedRef = useRef(false);
  const talons = useMegaMenu();
  const location = useLocation();
  const dispatch = useDispatch();
  const offcanvasEnquireRef = useRef(null);
  const { itemCount } = useCartTrigger({
    queries: {
      getItemCountQuery: GET_ITEM_COUNT_QUERY,
    },
  });
  const { MegaMenuData, categoryData } = talons;
  const paths = location?.pathname.split("/").filter((path) => path !== "");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  useEffect(() => {
    const alreadyShown = localStorage.getItem("enquirePopupShown");
    const manuallyOpened = sessionStorage.getItem("manuallyOpenedEnquire");
    if (
      showEnquireNow &&
      !showFeedback &&
      !ShowEnquireFormNow &&
      !alreadyShown &&
      !manuallyOpened
    ) {
      console.log("manuallyOpened", manuallyOpened);
      localStorage.setItem("enquirePopupShown", "true");
      setTimeout(() => {
        setShowEnquireFormNow(true);
        setTimeout(() => {
          const el = document.getElementById("offcanvasLeft");
          if (el) {
            const offcanvas = new Offcanvas(el, { backdrop: false });
            offcanvas.show();
            const removeBackdrop = () => {
              const backdropEl = document.querySelector(".offcanvas-backdrop");
              if (backdropEl) {
                backdropEl.remove();
                document.body.classList.remove(
                  "offcanvas-backdrop",
                  "show",
                  "modal-open"
                );
                document.body.style.overflow = "auto";
              }
            };

            removeBackdrop();
            setTimeout(removeBackdrop, 100);
            setTimeout(removeBackdrop, 300);

            setTimeout(() => {
              if (!isFormFocusedRef.current) {
                offcanvas.hide();
              }
            }, 2000);
          }
        }, 100);
      }, 100);
    }
  }, [showEnquireNow, showFeedback, ShowEnquireFormNow]);

  useEffect(() => {
    const el = offcanvasEnquireRef.current;
    if (!el) return;

    const handler = () => setShowEnquireFormNow(false);
    el.addEventListener("hidden.bs.offcanvas", handler);

    return () => {
      el.removeEventListener("hidden.bs.offcanvas", handler);
    };
  }, []);

  useEffect(() => {
    if (!paths.length) {
      dispatch(saveShowEnquireNow(true));
    } else if (paths[0] === "category" || paths[0] === "product") {
      return;
    } else {
      dispatch(saveShowEnquireNow(false));
    }
  }, [paths.length]);

  return (
    <>
      <main className={classes.root}>
        <Suspense fallback={<HeaderShimmer />}>
          <Header
            MegaMenuData={MegaMenuData}
            categoryData={categoryData}
            itemCount={itemCount}
          />
        </Suspense>
        <div className={classes.page}>{children}</div>

        <Suspense fallback={null}>
          <Footer MegaMenuData={MegaMenuData} />
        </Suspense>
      </main>

      <div className={classes.leftbutton}>
        <button
          className={`btn ${classes.btnbulk} ${classes.toggle1}`}
          data-bs-toggle="offcanvas"
          data-bs-target="#offcanvasRight"
          aria-controls="offcanvasRight"
          onClick={() => setShowFeedback(true)}
        >
          <Link className="">Feedback</Link>
        </button>

        {showEnquireNow ? (
          <button
            className={`btn ${classes.btnbulk1} ${classes.toggle2}`}
            data-bs-toggle="offcanvas"
            data-bs-target="#offcanvasLeft"
            aria-controls="offcanvasLeft"
            data-bs-backdrop="false"
            onClick={() => {
              sessionStorage.setItem("manuallyOpenedEnquire", "true");
              setShowEnquireFormNow(true);
            }}
          >
            <span>Enquire Now</span>
          </button>
        ) : null}

        <button className={`btn ${classes.btnshop}`}>
          <Link to="/catalogue" className="">
            Catalogue{" "}
            <img src={bookLogo} alt="catalogue" width={19} height={19} />
          </Link>
        </button>
      </div>

      <div
        className="offcanvas offcanvas-end"
        tabIndex="-1"
        id="offcanvasRight"
        aria-labelledby="offcanvasRightLabel"
      >
        <Suspense fallback={null}>
          {showFeedback ? (
            <FeedbackForm setShowFeedback={setShowFeedback} />
          ) : null}
        </Suspense>
      </div>

      <div
        ref={offcanvasEnquireRef}
        className={`offcanvas offcanvas-end ${classes.enquire_form}`}
        tabIndex="-1"
        id="offcanvasLeft"
        aria-labelledby="offcanvasLeftLabel"
        data-bs-backdrop="false"
      >
        <Suspense fallback={null}>
          {ShowEnquireFormNow ? (
            <EnquiryForm
              setShowEnquireFormNow={setShowEnquireFormNow}
              isFormFocusedRef={isFormFocusedRef}
            />
          ) : null}
        </Suspense>
      </div>
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.object.isRequired,
};

export default Layout;
